export default __webpack_public_path__ + "static/media/150_form_logo_dark@2x.46cbe7a3.png";